export const viewMileageRunReportTabs: IViewMileageRunReportTabs = {
  tireMileage: 'Tire Mileage',
  vehicleMileage: 'Vehicle Mileage',
};

export interface IViewMileageRunReportTabs {
    tireMileage: string;
    vehicleMileage: string;
}